/* Recipe detail. Added by Oleg @ IAKOE.
   <ts-recipe>: the ml/oz unit toggle rewrites each amount cell from its
   data-ml / data-oz. The gallery itself is the kit ia-slider (keen) — drag,
   dots and widths are its job; here we only mute the video of any slide that
   is no longer active, plus set playsinline / let native controls handle pause. */
if (!customElements.get('ts-recipe')) {
  customElements.define(
    'ts-recipe',
    class TsRecipe extends HTMLElement {
      connectedCallback() {
        // Back link: go back only when the previous page is on this site;
        // direct entry / external / unknown referrer keep the recipes-list href.
        const back = this.querySelector('[data-ts-back]');
        if (back) {
          let internal = false;
          try {
            internal = !!document.referrer && new URL(document.referrer).origin === location.origin;
          } catch (e) {
            /* malformed referrer — fall through to the recipes-list href */
          }
          if (internal) {
            back.addEventListener('click', (e) => {
              e.preventDefault();
              history.back();
            });
          }
        }

        // iOS Safari only autoplays inline video when the <video> carries
        // playsinline; the kit's video_tag omits it, so the muted background
        // videos otherwise refuse to play (or grab fullscreen) on mobile Safari.
        // Set it before the kit's ia-video calls play() on viewport-enter.
        this.querySelectorAll('video').forEach((v) => {
          v.playsInline = true;
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');
          // Once the kit shows native controls (sound mode), let the <video>'s
          // own controls handle play/pause/seek: stop the click bubbling to the
          // kit's <ia-video>, whose AutoplayStrategy.onClick has no
          // show_html_controls guard and would mute+reset instead of pausing.
          v.addEventListener('click', (e) => {
            if (v.controls) e.stopPropagation();
          });
        });

        this.unitWrap = this.querySelector('[data-ts-unit]');
        this.amounts = this.querySelectorAll('.ts-recipe__ing-amt');
        if (this.unitWrap) {
          // default unit comes from the store config resolver (theme setting or
          // shop metafield); anything unexpected falls back to ml
          this.unit = this.dataset.defaultUnit === 'oz' ? 'oz' : 'ml';
          const toggle = () => this.setUnit(this.unit === 'ml' ? 'oz' : 'ml');
          this.unitWrap.addEventListener('click', toggle);
          this.unitWrap.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggle();
            }
          });
          this.setUnit(this.unit);
        }

        // Gallery is the kit ia-slider (keen): it owns drag, dots and slide
        // widths. We only coordinate the video — when the active slide changes
        // (keen toggles .is-active on .ia-slider__slide), drop every non-active
        // slide's video back to muted background playback (sound off, controls
        // hidden, play button shown, keeps looping muted).
        const gallery = this.querySelector('.ts-recipe__gallery');
        if (gallery) {
          const muteSlideVideo = (slide) => {
            const v = slide.querySelector('ia-video');
            if (v && v.strategy && v.controller && !v.strategy.isPreview()) {
              v.strategy.enterPreviewMode(); // state -> preview + mute()
              v.controller.activeVideo?.removeAttribute('controls');
              v.controller.play(false); // stay playing, just muted
              v.render(); // restores the play button, hides the controls
            }
          };
          const syncVideos = () => {
            gallery.querySelectorAll('.ia-slider__slide').forEach((slide) => {
              if (!slide.classList.contains('is-active')) muteSlideVideo(slide);
            });
          };
          // converges: muteSlideVideo no-ops once a video is back in preview.
          new MutationObserver(syncVideos).observe(gallery, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class'],
          });
        }
      }
      setUnit(unit) {
        this.unit = unit;
        this.unitWrap.classList.toggle('is-oz', unit === 'oz');
        this.amounts.forEach((cell) => {
          cell.textContent = cell.dataset[unit] || '';
        });
      }
    }
  );
}
